export const clone = obj => JSON.parse(JSON.stringify(obj));

export const normalizarBusca = (texto = '') => String(texto)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim();

export const hexToRgb = (hex) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export const getContrast = (hex) => {
    const { r, g, b} = hexToRgb(hex);

    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
        ? {theme: 'dark', color: '#000'}
        : {theme: 'light', color: '#fff'};
}

export const corSobre = (hex, padrao = '#fff') => {
    try {
        return getContrast(String(hex).substring(0, 7)).color;
    } catch (e) {
        return padrao;
    }
};

export const isMobile = () => window.matchMedia('(any-pointer:coarse)').matches;
